import React from 'react';

const LoadingSpinner = ({ message = "Chargement...", size = "normal", className = "" }) => {
    const sizeClasses = {
        small: "w-4 h-4",
        normal: "w-8 h-8",
        large: "w-12 h-12"
    };

    const textSizeClasses = {
        small: "text-xs",
        normal: "text-sm",
        large: "text-base"
    };

    return (
        <div className={`flex flex-col items-center justify-center ${className}`}>
            <div className="relative">
                <div className={`${sizeClasses[size]} border-4 border-blue-200 rounded-full animate-spin`}></div>
                <div className={`${sizeClasses[size]} border-4 border-transparent border-t-blue-500 rounded-full animate-spin absolute top-0 left-0`}></div>
            </div>
            <p className={`mt-3 text-gray-600 font-medium ${textSizeClasses[size]}`}>
                {message}
            </p>
            <div className="flex gap-1 mt-2">
                <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
                <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
                <div className="w-2 h-2 bg-blue-300 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
            </div>
        </div>
    );
};

export default LoadingSpinner;